<!--
 * @Description: 运单中心-运单详情-运单节点
 * @Author: lufenggang
 * @Date: 2020-09-03 10:50:35
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-07-27 16:15:02
-->
<template>
  <div class="node-list">
    <el-timeline>
      <!-- <el-timeline-item
        :timestamp="item.customAreaName"
        :title="item.customAreaName"
        :class="{
          disable: item.arrive !== 1
        }"
        placement="top"
        v-for="(item, idx) in nodeData"
        :key="item.key"
      > -->
      <el-timeline-item
        :class="{
          disable: item.arrive !== 1
        }"
        v-for="(item, idx) in nodeData"
        :key="item.key"
      >
        <div class="node-title">
          <em
            class="tag blue"
            :class="{
              disable: item.arrive !== 1
            }"
            v-if="item.nodeType === 1 || item.nodeType === 3"
            >装</em
          >
          <em
            class="tag purple"
            :class="{
              disable: item.arrive !== 1
            }"
            v-if="item.nodeType === 2 || item.nodeType === 3"
            >卸</em
          >
          <em
            class="tag blue-green"
            :class="{
              disable: item.arrive !== 1
            }"
            v-if="item.nodeType === 4"
            >途</em
          >
          <em
            class="tag green"
            :class="{
              disable: item.arrive !== 1
            }"
            v-if="item.nodeType === 5"
            >返</em
          >
          <span
            class="node-name"
            :class="{
              disable: item.arrive !== 1
            }"
          >
            {{ item.customAreaName }}</span
          >
        </div>
        <div class="node-item">
          <!-- 节点序号 -->
          <div class="node-idx">{{ idx + 1 }}</div>
          <!-- 到达时间 -->
          <div
            :class="{
              'node-arrival': true,
              hide: !item.requiredArriveTime && !item.actualArriveTime
            }"
          >
            <!-- 到达要求时间 -->
            <p v-if="item.requiredArriveTime">
              <span class="node-text">要求</span>{{ item.requiredArriveTime }}
            </p>
            <!-- 到达时间时间 -->
            <p v-if="item.actualArriveTime && item.arrive === 1">
              <span class="node-text">实际</span>{{ item.actualArriveTime }}
              <!-- 准晚点 -->
              <span
                v-if="item.arriveState"
                :class="{
                  'time-tag': true,
                  'is-time': item.arriveState === 1,
                  'is-advance': item.arriveState === 2,
                  'is-late': item.arriveState === 3
                }"
                >({{
                  showStatusLabel(
                    item.arriveState,
                    item.arriveActualTimeDiffStr
                  )
                }})</span
              >
            </p>
            <!-- 温度路数 -->
            <p v-if="item.temperature && item.temperature.length">
              <span
                v-for="node in item.temperature"
                :key="node.key"
                class="alarm-temper"
                >{{ node.name }}({{ node.value }})</span
              >
            </p>
          </div>
          <!-- 离开时间 -->
          <div
            :class="{
              'node-leave': true,
              hide: !item.requiredLeaveTime && !item.actualLeaveTime
            }"
          >
            <!-- 离开要求时间 -->
            <p v-if="item.requiredLeaveTime">
              <span class="node-text">要求</span>{{ item.requiredLeaveTime }}
            </p>
            <!-- 离开到达时间 -->
            <p v-if="item.actualLeaveTime && item.arrive === 1">
              <span class="node-text">实际</span>{{ item.actualLeaveTime }}
              <!-- 准晚点 -->
              <span
                v-if="item.leaveState"
                :class="{
                  'time-tag': true,
                  'is-time': item.leaveState === 1,
                  'is-advance': item.leaveState === 2,
                  'is-late': item.leaveState === 3
                }"
                >({{
                  showStatusLabel(item.leaveState, item.leaveActualTimeDiffStr)
                }})</span
              ><span class="alarm-duration" v-if="item.stayTime">
                （停留时长：{{ item.stayTimeStr }}）</span
              >
            </p>
          </div>
          <!-- 节点报警 -->
          <!-- isLineAlarm lineAlarmList -->
          <div class="node-alarm" v-if="item.isNodeAlarm === 1">
            <i class="e6-icon-alarm_line"></i>
            <p v-for="node in item.nodeAlarmList" :key="node.key">
              <span> {{ node.beginTime }} ~ {{ node.endTime }}</span>
              <span class="alarm-type">{{ node.lastAlarmTypeName }}</span>
            </p>
          </div>
          <!-- 节点间流程报警 -->
          <div class="node-alarm" v-if="item.isLineAlarm === 1">
            <i class="e6-icon-alarm_fill node-icon"></i>
            <p
              v-for="node in item.lineAlarmList"
              :key="node.key"
              class="is-node"
            >
              <span> {{ node.beginTime }} ~ {{ node.endTime }}</span>
              <span class="alarm-type">{{ node.lastAlarmTypeName }}</span>
            </p>
          </div>
        </div>
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
import base from "e6-base-carrier-3.0/mixins/base";
export default {
  name: "waybillNode",
  mixins: [base],
  props: {
    //节点列表数据
    nodeData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  methods: {
    showStatusLabel(status, timeStr) {
      return status === 1
        ? "准点"
        : status === 2
        ? `提前${timeStr}`
        : status === 3
        ? `晚点${timeStr}`
        : "";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~e6-base-carrier-3.0/styles/variables";
// 节点
.node-list {
  background-color: $--color-white;
  padding: 15px 10px;
  overflow-y: auto;
  height: 670px;

  /deep/.el-timeline-item {
    .el-timeline-item__timestamp {
      color: #000;
      padding-top: 12px;
      font-weight: 600;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .el-timeline-item__wrapper {
      padding-left: 40px;
      margin-bottom: -22px;
    }

    .el-timeline-item__tail {
      border-color: $--color-primary;
      left: 12px;
    }

    .el-timeline-item__node {
      width: 30px;
      height: 30px;
      background-color: #46a1fd;
    }
    .node-title {
      display: flex;
      align-items: center;
      .node-name {
        color: #000;
        padding-top: 12px;
        padding-left: 3px;
        font-weight: 600;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        &.disable {
          color: #e4e7ed;
        }
      }
      .tag {
        font-size: 12px;
        font-style: normal;
        color: #fefefe;
        width: 18px;
        height: 18px;
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 12px 2px 0 2px;
        &.blue {
          background: #46a1fd;
        }
        &.purple {
          background: #a877e5;
        }
        &.blue-green {
          background: #00bebc;
        }
        &.green {
          background: #78c950;
        }
        &.disable {
          background: #e4e7ed;
        }
      }
    }

    .node-item {
      padding: 5px 0 0 25px;
      position: relative;

      .node-idx {
        position: absolute;
        top: -19px;
        left: -31px;
        font-size: 14px;
        font-weight: 600;
        color: $--color-white;
      }

      .node-arrival,
      .node-leave {
        position: relative;
        margin: 0 0 15px 0;
        &.hide {
          &::after {
            display: none;
          }
        }

        .node-text {
          padding: 0 10px 0 0;
        }

        .time-tag,
        .alarm-temper,
        .alarm-duration {
          font-size: 12px;
        }

        .alarm-temper {
          padding: 0 20px 5px 0;
          display: inline-block;
        }

        .time-tag.is-time {
          color: #3693fd;
        }

        .time-tag.is-advance {
          color: $--color-status--order-6;
        }

        .time-tag.is-late {
          color: $--color-status--assist-3;
        }

        &::after {
          display: block;
          background-color: #e6ebf2;
          color: #849bbd;
          position: absolute;
          top: 0;
          left: -25px;
          font-size: 12px;
          padding: 2px 3px;
          border-radius: 3px;
        }
      }

      .node-arrival {
        &::after {
          content: "到";
        }
      }

      .node-leave {
        &::after {
          content: "离";
        }
      }
      .node-alarm {
        position: relative;
        color: $--color-status--assist-3;

        .e6-icon-alarm_line {
          position: absolute;
          top: -6px;
          left: -24px;
          font-size: 18px;
        }

        .node-icon {
          position: absolute;
          bottom: 15px;
          left: -65px;
          color: #f45a5a;
          font-size: 26px;
          background-color: $--color-white;
        }

        .is-node {
          margin-left: -20px;
        }

        .alarm-type {
          padding: 0 10px;
        }

        p {
          font-size: 12px;
        }
      }
      p {
        margin: 0 0 10px 0;
        font-size: 14px;
      }
    }
  }

  /deep/.el-timeline-item.disable {
    .el-timeline-item__timestamp {
      color: #e4e7ed;
    }

    .el-timeline-item__tail {
      border-color: #e4e7ed;
    }

    .el-timeline-item__node {
      background-color: #e4e7ed;
    }

    .node-arrival,
    .node-leave {
      &::after {
        color: $--color-white;
        background-color: #e4e7ed;
      }

      .time-tag {
        color: #e4e7ed !important;
      }
    }

    .node-arrival.hide,
    .node-leave.hide {
      &::after {
        display: none;
      }
    }

    p {
      color: #c0c4cc;
    }
  }
}
</style>
